import React from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Header, Icon, Message, Segment } from 'semantic-ui-react'
import { CardAttributeWrapper, StyledSegmentWrapper } from '~/pages/Dairy/MilkMoney/style'
import { FormFields } from '~/components/FormFields'

const VATItems: React.FC = () => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'saleTaxes',
    keyName: 'key'
  })

  async function handleAddVat() {
    append({
      id: null,
      name: '',
      percent: ''
    })
  }

  function renderNoResultsMessage() {
    return <Message info>
      <Message.Header>{t('No results')}</Message.Header>
      <p>{t('Sorry, there are no VAT to display.')}</p>
    </Message>
  }

  function renderForm() {
    return fields.map((field, index) => {
      return <CardAttributeWrapper key={field.key}>
        <div className='cardSettings'>
          {
            !field['id'] && <div className='deleteWrapper' onClick={() => remove(index)}>
              <Icon
                inverted
                color='red'
                circular
                name='trash'
              />
            </div>
          }
          <FormFields.Input
            control={control}
            name={`saleTaxes[${index}].name`}
            label={t('Name')}
            placeholder={t('Enter name')}
            rules={{
              required: {
                value: true,
                message: t('Please enter name')
              },
              maxLength: {
                value: 50,
                message: t('Max number of char. is 50')
              }
            }}
          />
          <FormFields.Input
            control={control}
            typeInput={'controled'}
            allowDecimals
            decimalScale={2}
            rules={{
              required: {
                value: true,
                message: t('Please enter percent')
              },
              min: {
                value: 0,
                message: t('Min value is 0')
              }
            }}
            name={`saleTaxes[${index}].percent`}
            label={t('Percent')}
            placeholder={t('Enter percent')}
          />
          <FormFields.Checkbox
            control={control}
            defaultValue={0}
            checkboxValue={1}
            name={`saleTaxes[${index}].status`}
            label={t('Status')}
          />
        </div>
      </CardAttributeWrapper>
    })
  }

  return <StyledSegmentWrapper>
    <Header attached='top' block>
      <div className='title'>{t('Vat')}</div>
      <Button
        type='button'
        secondary
        content={t('Add new VAT form')}
        onClick={() => handleAddVat()}
      />
    </Header>
    <Segment
      attached
      className={`${fields.length === 0 ? 'messageClass' : 'segmetBody'}`}
    >
      {fields.length > 0 ? renderForm() : renderNoResultsMessage()}
    </Segment>
  </StyledSegmentWrapper>
}
export default VATItems